import * as React from "react";
import HusklyLogo from "../HusklyLogo";

const Nav = () => (
  <header className="sticky top-0 z-30 backdrop-blur bg-stone-50/80 border-b border-stone-200">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
      <a href="/" className="flex items-center gap-2.5">
        <HusklyLogo
          className="w-7 h-7 text-stone-900"
          style={{ fill: "currentColor" }}
        />
        <span className="font-serif text-xl tracking-tight text-stone-900">
          Huskly
        </span>
      </a>
      <nav className="hidden sm:flex items-center gap-8 text-sm text-stone-600">
        <a href="#about" className="hover:text-stone-900 transition-colors">
          About
        </a>
        <a href="#projects" className="hover:text-stone-900 transition-colors">
          Projects
        </a>
        <a
          href="#open-source"
          className="hover:text-stone-900 transition-colors"
        >
          Open source
        </a>
        <a
          href="https://github.com/orgs/huskly/repositories"
          target="_blank"
          rel="noreferrer"
          className="hover:text-stone-900 transition-colors"
        >
          GitHub
        </a>
      </nav>
    </div>
  </header>
);

export default Nav;
